import { createReducer, on } from '@ngrx/store';
import { ResponsibleOfficial } from 'brain-data/model/responsible-official.model';
import {
  createResponsibleOfficialSuccess,
  deleteResponsibleOfficialSuccess,
  loadResponsibleOfficials,
  loadResponsibleOfficialsError,
  loadResponsibleOfficialsSuccess,
  updateResponsibleOfficialSuccess,
} from '../actions/responsible-official.action';

export default interface ResponsibleOfficialState {
  officials: ResponsibleOfficial[];
  loading: boolean;
  loaded: boolean;
  error?: Error;
}

export const initialState: ResponsibleOfficialState = {
  officials: [],
  loading: false,
  loaded: false,
  error: undefined,
};

const sortByName = (a: ResponsibleOfficial, b: ResponsibleOfficial) =>
  a.fullName.localeCompare(b.fullName);

export const reducer = createReducer(
  initialState,

  on(loadResponsibleOfficials, (state): ResponsibleOfficialState => ({ ...state, loading: true, error: undefined })),
  on(loadResponsibleOfficialsSuccess, (state, { officials }): ResponsibleOfficialState => ({
    ...state,
    officials: [...officials].sort(sortByName),
    loading: false,
    loaded: true,
  })),
  on(loadResponsibleOfficialsError, (state, { error }): ResponsibleOfficialState => ({
    ...state,
    loading: false,
    error,
  })),

  on(createResponsibleOfficialSuccess, (state, { official }): ResponsibleOfficialState => ({
    ...state,
    officials: [...state.officials, official].sort(sortByName),
  })),

  on(updateResponsibleOfficialSuccess, (state, { official }): ResponsibleOfficialState => ({
    ...state,
    officials: state.officials.map(o => (o.id === official.id ? official : o)).sort(sortByName),
  })),

  on(deleteResponsibleOfficialSuccess, (state, { id }): ResponsibleOfficialState => ({
    ...state,
    officials: state.officials.filter(o => o.id !== id),
  })),
);
